// extracted by mini-css-extract-plugin
export default {"pageContainer":"frontpage_pageContainer__u4p4Y","video":"frontpage_video__eEWUW","frontContainer":"frontpage_frontContainer__XsEBk"};